<template>
  <div class="grid-container">
    <div v-if="!loading" class="grid-x">
      <h3 class="cell subtitle">Top Embajadores del Fútbol en DS:</h3>
      <div 
        class="cell small-6 medium-3 large-2"
        v-for="(embajador, index) in embajadores"
        :key="embajador.id">
          <v-simple-person-card 
            :image="embajador.avatar"
            :name="embajador.full_name"
            :texto="embajador.torneos + ' torneos'"
            :tag="(index+1) + '°'"
          />
      </div>
    </div>
    <div v-else>
      <app-loading />
    </div>
  </div>
</template>

<script>

  import { listaTopOrganizers } from '@/api/Home'

  import VSimplePersonCard from '@/components/base/VSimplePersonCard.vue'

  export default {
    name: 'TheTopEmbajadores',
    components: {
      VSimplePersonCard
    },
    data() {
      return {
        embajadores: [],
        loading: false
      }
    },
    methods: {
      cargarEmbajadores: function () {
        this.loading = true
        listaTopOrganizers().then(
          (response) => {
            this.loading = false
            this.embajadores = response.data
          }
        ).catch (
          () => this.loading = false
        )
      }
    },
    mounted() {
      this.cargarEmbajadores()
    },
  }
</script>

<style lang="scss" scoped>

</style>